mainApp.directive('bgpNeighbor', function() {
    return {
        templateUrl: '/public/directives/bgpNeighbor.html',
        scope: {
            isSocketSite: '<',
            neighbor: '=',
            lastIndex: '='
        },
        controller:  ['$scope', function($scope, $timeout, $state, $rootScope,LocationService) {

            $scope.useMd5 = $scope.neighbor.md5AuthKey ? true : false;
            $scope.neighbor.description= $scope.neighbor.description != null? $scope.neighbor.description : ('Neighbor #' + $scope.lastIndex);
            $scope.neighbor.catoAsn = $scope.neighbor.catoAsn != null ? $scope.neighbor.catoAsn : 64515;
            $scope.neighbor.advertiseDefaultRoute = $scope.neighbor.advertiseDefaultRoute != null ? $scope.neighbor.advertiseDefaultRoute : true;

            //removes auth key in case "user MD5" is unchecked
            $scope.handleAuthKey = function(){
                if(!$scope.useMd5) {
                    $scope.neighbor.md5AuthKey = '';
                }
            }

            $scope.onHoldTimeChange = function() {
                if ($scope.neighbor.holdTime === 0) {
                    $scope.neighbor.keepaliveInterval = 0;
                } else if ($scope.neighbor.holdTime > 0 && $scope.neighbor.keepaliveInterval === 0) {
                    $scope.neighbor.keepaliveInterval = 1;
                }
            }
        }]
    }
});
